import React, { useEffect, useState } from 'react';
import { UserPlus, ShieldCheck, UploadCloud, RefreshCw } from 'lucide-react';
import UserManagementModal from './AccessManagement/UserManagementModal';
import AssignUsersModal from './AccessManagement/AssignUsersModal';
import { roleService } from '../../../components/api/roleService';
import { apiService } from '../../../components/api/apiService';
import { RoleWithUsersDto, User, } from '../interfaces/Users';
import ViewRoutePrivilegesModal from './Access/ViewRoutePrivilegesModal';
export interface RoutePrivilege {
  id: string;
  uid: string;
  label: string;
  path: string | null;
  icon: string;
  hasAccess: boolean;
  children?: RoutePrivilege[];
}
const mockRoutes = [
  {
    "id": "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    "uid": "home",
    "label": "Home",
    "path": "/",
    "icon": "Home",
    "hasAccess": true
  },
  {
    "id": "b2c3d4e5-f6g7-8901-bcde-f12345678901",
    "uid": "workflows",
    "label": "Workflows",
    "path": "/workflows",
    "icon": "Workflow",
    "hasAccess": true,
    "children": [
      {
        "id": "c3d4e5f6-g7h8-9012-cdef-123456789012",
        "uid": "workflows_create",
        "label": "Create New",
        "path": "/workflows/create",
        "icon": "PlusSquare",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "6f3a0f4c-20b7-4c2a-b4c1-7caaed2358b7",
    "uid": "Applications",
    "label": "Applications",
    "path": "/applications",
    "icon": "AppWindow",
    "hasAccess": true
  },
  {
    "id": "d4e5f6g7-h8i9-0123-def1-234567890123",
    "uid": "agents",
    "label": "Agents",
    "path": "/agents",
    "icon": "Bot",
    "hasAccess": true,
    "children": [
      {
        "id": "e5f6g7h8-i9j0-1234-ef12-345678901234",
        "uid": "agent_studio",
        "label": "Agent Studio",
        "path": "/agents/studio",
        "icon": "LayoutTemplate",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "f6g7h8i9-j0k1-2345-f123-456789012345",
    "uid": "entities",
    "label": "Entities",
    "path": "/entities",
    "icon": "Database",
    "hasAccess": true,
    "children": [
      {
        "id": "g7h8i9j0-k1l2-3456-1234-567890123456",
        "uid": "entities_new",
        "label": "New Entity",
        "path": "/entities/new",
        "icon": "FilePlus",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "h8i9j0k1-l2m3-4567-2345-678901234567",
    "uid": "knowledge_workspace",
    "label": "Knowledge Workspace",
    "path": "/knowledge",
    "icon": "BookOpen",
    "hasAccess": true,
    "children": [
      {
        "id": "i9j0k1l2-m3n4-5678-3456-789012345678",
        "uid": "knowledge_add",
        "label": "Add New",
        "path": "/knowledge/add",
        "icon": "FilePlus2",
        "hasAccess": true
      },
      {
        "id": "j0k1l2m3-n4o5-6789-4567-890123456789",
        "uid": "knowledge_manage",
        "label": "Manage",
        "path": "/knowledge/manage",
        "icon": "Settings",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "k1l2m3n4-o5p6-7890-5678-901234567890",
    "uid": "llm_routing",
    "label": "LLM Routing",
    "path": "/llm-routing",
    "icon": "Brain",
    "hasAccess": true,
    "children": [
      {
        "id": "l2m3n4o5-p6q7-8901-6789-012345678901",
        "uid": "llm_add",
        "label": "Add New",
        "path": "/llm-routing/add",
        "icon": "FilePlus",
        "hasAccess": true
      },
      {
        "id": "m3n4o5p6-q7r8-9012-7890-123456789012",
        "uid": "llm_edit",
        "label": "Edit",
        "path": "/llm-routing/edit",
        "icon": "Edit3",
        "hasAccess": true
      },
      {
        "id": "n4o5p6q7-r8s9-0123-8901-234567890123",
        "uid": "llm_delete",
        "label": "Delete",
        "path": "/llm-routing/delete",
        "icon": "Trash2",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "o5p6q7r8-s9t0-1234-9012-345678901234",
    "uid": "data_vault",
    "label": "Data Vault",
    "path": "/data-vault",
    "icon": "Vault",
    "hasAccess": true,
    "children": [
      {
        "id": "p6q7r8s9-t0u1-2345-0123-456789012345",
        "uid": "data_add",
        "label": "Add New",
        "path": "/data-vault/add",
        "icon": "FilePlus",
        "hasAccess": true
      },
      {
        "id": "q7r8s9t0-u1v2-3456-1234-567890123456",
        "uid": "data_edit",
        "label": "Edit",
        "path": "/data-vault/edit",
        "icon": "Edit",
        "hasAccess": true
      },
      {
        "id": "r8s9t0u1-v2w3-4567-2345-678901234567",
        "uid": "data_delete",
        "label": "Delete",
        "path": "/data-vault/delete",
        "icon": "Trash",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "s9t0u1v2-w3x4-5678-3456-789012345678",
    "uid": "schedules",
    "label": "Schedules",
    "path": "/schedules",
    "icon": "CalendarClock",
    "hasAccess": true,
    "children": [
      {
        "id": "t0u1v2w3-x4y5-6789-4567-890123456789",
        "uid": "schedule_configure",
        "label": "Configure Schedule",
        "path": "/schedules/configure",
        "icon": "Settings2",
        "hasAccess": true
      },
      {
        "id": "u1v2w3x4-y5z6-7890-5678-901234567890",
        "uid": "schedule_logs",
        "label": "Logs",
        "path": "/schedules/logs",
        "icon": "ScrollText",
        "hasAccess": true
      },
      {
        "id": "v2w3x4y5-z6a7-8901-6789-012345678901",
        "uid": "schedule_trigger",
        "label": "Run/Trigger",
        "path": "/schedules/run",
        "icon": "PlayCircle",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "w3x4y5z6-a7b8-9012-7890-123456789012",
    "uid": "intent_orchestration",
    "label": "Intent Orchestration",
    "path": "/intents",
    "icon": "Zap",
    "hasAccess": true,
    "children": [
      {
        "id": "x4y5z6a7-b8c9-0123-8901-234567890123",
        "uid": "intent_new",
        "label": "New Model",
        "path": "/intents/new",
        "icon": "Sparkle",
        "hasAccess": true
      },
      {
        "id": "y5z6a7b8-c9d0-1234-9012-345678901234",
        "uid": "intent_edit",
        "label": "Edit",
        "path": "/intents/edit",
        "icon": "Edit3",
        "hasAccess": true
      },
      {
        "id": "z6a7b8c9-d0e1-2345-0123-456789012345",
        "uid": "intent_delete",
        "label": "Delete",
        "path": "/intents/delete",
        "icon": "Trash",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "a7b8c9d0-e1f2-3456-1234-567890123456",
    "uid": "deployments",
    "label": "Deployments",
    "path": "/deployments",
    "icon": "Rocket",
    "hasAccess": true,
    "children": [
      {
        "id": "b8c9d0e1-f2g3-4567-2345-678901234567",
        "uid": "deployment_new",
        "label": "New",
        "path": "/deployments/new",
        "icon": "Plus",
        "hasAccess": true
      },
      {
        "id": "c9d0e1f2-g3h4-5678-3456-789012345678",
        "uid": "deployment_test",
        "label": "Test",
        "path": "/deployments/test",
        "icon": "TestTube2",
        "hasAccess": true
      },
      {
        "id": "d0e1f2g3-h4i5-6789-4567-890123456789",
        "uid": "deployment_delete",
        "label": "Delete",
        "path": "/deployments/delete",
        "icon": "Trash2",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "e1f2g3h4-i5j6-7890-5678-901234567890",
    "uid": "connections",
    "label": "Connection & Keys",
    "path": "/connections",
    "icon": "KeyRound",
    "hasAccess": true,
    "children": [
      {
        "id": "f2g3h4i5-j6k7-8901-6789-012345678901",
        "uid": "connection_new",
        "label": "New",
        "path": "/connections/new",
        "icon": "PlusCircle",
        "hasAccess": true
      },
      {
        "id": "g3h4i5j6-k7l8-9012-7890-123456789012",
        "uid": "connection_edit",
        "label": "Edit",
        "path": "/connections/edit",
        "icon": "Edit",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "h4i5j6k7-l8m9-0123-8901-234567890123",
    "uid": "access_settings",
    "label": "Access Setting",
    "path": "/access",
    "icon": "ShieldCheck",
    "hasAccess": true,
    "children": [
      {
        "id": "i5j6k7l8-m9n0-1234-9012-345678901234",
        "uid": "access_users",
        "label": "User Management",
        "path": "/access/users",
        "icon": "Users2",
        "hasAccess": true
      },
      {
        "id": "j6k7l8m9-n0o1-2345-0123-456789012345",
        "uid": "access_roles",
        "label": "Role Configuration",
        "path": "/access/roles",
        "icon": "UserCog2",
        "hasAccess": true
      },
      {
        "id": "k7l8m9n0-o1p2-3456-1234-567890123456",
        "uid": "access_rights",
        "label": "Role Rights",
        "path": "/access/rights",
        "icon": "LockKeyhole",
        "hasAccess": true
      },
      {
        "id": "l8m9n0o1-p2q3-4567-2345-678901234567",
        "uid": "access_assign",
        "label": "Assign Users",
        "path": "/access/assign",
        "icon": "UserPlus",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "h4b7c2d1-8f3a-4e6b-9c21-1a2b3c4d5e6f",
    "uid": "mcp_access_manager",
    "label": "MCP Access Manager",
    "path": "/portal/mcpdevelopers",
    "icon": "ShieldCheck",
    "hasAccess": true,
    "children": [
      {
        "id": "a1d2f3b4-5c6e-47a8-9b01-2c3d4e5f6a7b",
        "uid": "mcp_dashboard",
        "label": "MCP Dashboard",
        "path": "/portal/mcpdashboard",
        "icon": "LayoutDashboard",
        "hasAccess": true
      },
      {
        "id": "b2e3c4d5-6f7a-48b9-0c12-3d4e5f6a7b8c",
        "uid": "mcp_developer_access",
        "label": "Developer Access",
        "path": "/portal/mcpdevelopers",
        "icon": "ShieldCheck",
        "hasAccess": true
      },
      {
        "id": "c3f4d5e6-7a8b-49c0-1d23-4e5f6a7b8c9d",
        "uid": "mcp_resources",
        "label": "MCP Resources",
        "path": "/portal/mcpresources",
        "icon": "Database",
        "hasAccess": true
      },
      {
        "id": "d4a5e6f7-8b9c-40d1-2e34-5f6a7b8c9d0e",
        "uid": "mcp_monitoring",
        "label": "Monitoring",
        "path": "/portal/mcplivemonitor",
        "icon": "Activity",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "m9n0o1p2-q3r4-5678-3456-789012345678",
    "uid": "system_settings",
    "label": "System Setting",
    "path": "/system",
    "icon": "Settings",
    "hasAccess": true
  },
  {
    "id": "n0o1p2q3-r4s5-6789-4567-890123456789",
    "uid": "my_account",
    "label": "My Account",
    "path": "/account",
    "icon": "UserCircle",
    "hasAccess": true
  },
  {
    "id": "o1p2q3r4-s5t6-7890-5678-901234567890",
    "uid": "logs",
    "label": "Logs",
    "path": "/logs",
    "icon": "ScrollText",
    "hasAccess": true
  },
  {
    "id": "p2q3r4s5-t6u7-8901-6789-012345678901",
    "uid": "reports",
    "label": "Reports",
    "path": "/reports",
    "icon": "BarChart3",
    "hasAccess": true
  },
  {
    "id": "q3r4s5t6-u7v8-9012-7890-123456789012",
    "uid": "chat",
    "label": "Chat",
    "path": "/chat",
    "icon": "MessageCircle",
    "hasAccess": true,
    "children": [
      {
        "id": "r4s5t6u7-v8w9-0123-8901-234567890123",
        "uid": "chat_reports",
        "label": "Custom Reports",
        "path": "/chat/reports",
        "icon": "FileBarChart",
        "hasAccess": true
      },
      {
        "id": "s5t6u7v8-w9x0-1234-9012-345678901234",
        "uid": "chat_triggers",
        "label": "Custom Triggers",
        "path": "/chat/triggers",
        "icon": "Zap",
        "hasAccess": true
      },
      {
        "id": "t6u7v8w9-x0y1-2345-0123-456789012345",
        "uid": "chat_dashboards",
        "label": "Dashboards",
        "path": "/chat/dashboards",
        "icon": "LayoutDashboard",
        "hasAccess": true
      },
      {
        "id": "u7v8w9x0-y1z2-3456-1234-567890123456",
        "uid": "chat_favorites",
        "label": "Favorites",
        "path": "/chat/favorites",
        "icon": "Star",
        "hasAccess": true
      },
      {
        "id": "v8w9x0y1-z2a3-4567-2345-678901234567",
        "uid": "chat_history",
        "label": "History",
        "path": "/chat/history",
        "icon": "History",
        "hasAccess": true
      }
    ]
  }
]
const nonAdminRoutes = [
  {
    "id": "q3r4s5t6-u7v8-9012-7890-123456789012",
    "uid": "chat",
    "label": "Chat",
    "path": "/chat",
    "icon": "MessageCircle",
    "hasAccess": true,
    "children": [
      {
        "id": "r4s5t6u7-v8w9-0123-8901-234567890123",
        "uid": "chat_reports",
        "label": "Custom Reports",
        "path": "/chat/reports",
        "icon": "FileBarChart",
        "hasAccess": true
      },
      {
        "id": "s5t6u7v8-w9x0-1234-9012-345678901234",
        "uid": "chat_triggers",
        "label": "Custom Triggers",
        "path": "/chat/triggers",
        "icon": "Zap",
        "hasAccess": true
      },
      {
        "id": "t6u7v8w9-x0y1-2345-0123-456789012345",
        "uid": "chat_dashboards",
        "label": "Dashboards",
        "path": "/chat/dashboards",
        "icon": "LayoutDashboard",
        "hasAccess": true
      },
      {
        "id": "u7v8w9x0-y1z2-3456-1234-567890123456",
        "uid": "chat_favorites",
        "label": "Favorites",
        "path": "/chat/favorites",
        "icon": "Star",
        "hasAccess": true
      },
      {
        "id": "v8w9x0y1-z2a3-4567-2345-678901234567",
        "uid": "chat_history",
        "label": "History",
        "path": "/chat/history",
        "icon": "History",
        "hasAccess": true
      }
    ]
  }
]
const AccessSettings = () => {
  const [roles, setRoles] = useState<RoleWithUsersDto[]>([]);
  const [loading, setLoading] = useState(true);
  const [showUserModal, setShowUserModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [allSystemUsers, setAllSystemUsers] = useState<User[]>([]);
  const [activeRole, setActiveRole] = useState<RoleWithUsersDto | null>(null);
  const [isAdmin, setIsAdmin] = useState(false);

  const tenantId = '6a6eee6f-75d7-4479-892d-80b5f225e004'; // Replace with real value or from context/JWT

  const [showRoutesModal, setShowRoutesModal] = useState(false);
  const [routesForRole, setRoutesForRole] = useState<RoutePrivilege[]>([]);

  const handleViewRoutes = async (role: RoleWithUsersDto) => {
    try {
      const response = await apiService.get(
        `/api/RoutePermission`,
        {
          tenantId: tenantId,
          roleId: role.roleId
        },
        'backend'
      );

      // If no routes configured yet, fallback to mock template
      const routes: RoutePrivilege[] =
        response.length === 0
          ? !role.isadmin
            ? nonAdminRoutes
            : mockRoutes
          : response;

      setIsAdmin(role.isadmin);
      setRoutesForRole(routes);
      setActiveRole(role);

      setShowRoutesModal(true);
    } catch (error) {
      console.error('Failed to load route permissions:', error);
      // Still fallback to mockRoutes if API fails
      setRoutesForRole(mockRoutes);
      setActiveRole(role);
      setShowRoutesModal(true);
    }
  };


  // Fetch roles on initial load
  useEffect(() => {
    refreshRoles();
  }, []);

  // API to refresh roles
  const refreshRoles = async () => {
    try {
      const response = await apiService.get('/api/auth/roles/users', {}, 'backend');
      setRoles(response);
    } catch (error) {
      console.error('Failed to fetch roles:', error);
    } finally {
      setLoading(false);
    }
  };


  // Open "Assign Users" modal
  const handleAssignClick = async (role: RoleWithUsersDto) => {
    try {
      setActiveRole(role);
      const response = await apiService.get('/api/auth/users', {}, 'backend');
      setAllSystemUsers(response);
      setShowAssignModal(true);
    } catch (error) {
      console.error('Failed to fetch users:', error);
    }
  };

  // Assign user to role
  const handleAssignUser = async (userId: string) => {
    try {
      await apiService.post('/api/auth/users/updaterole', {
        userID: userId,
        id: userId,
        roleID: activeRole?.roleId,
        tenantId: tenantId
      }, 'backend');
      await refreshRoles();
      setShowAssignModal(false);
    } catch (error) {
      console.error('Failed to assign user:', error);
    }
  };

  // Remove user from role
  const handleRemoveUser = async (userId: string) => {
    try {
      await apiService.post('/api/auth/roles/remove-user', {
        userID: userId,
        roleID: activeRole?.roleId,
        tenantId: tenantId
      }, 'backend');
      await refreshRoles();
      setShowAssignModal(false);
    } catch (error) {
      console.error('Failed to remove user from role:', error);
    }
  };

  return (
    <div className="space-y-6 max-w-5xl mx-auto">
      <div>
        <h2 className="text-xl font-semibold text-white">Access Settings</h2>
        <p className="text-sm text-gray-400">
          Manage user roles and access control. Import users from identity providers or assign them manually.
        </p>
      </div>

      <div className="flex flex-wrap gap-3">
        <button className="flex items-center gap-2 bg-neutral-800 hover:bg-neutral-700 border border-neutral-700 px-4 py-2 text-sm rounded-md text-gray-200">
          <UploadCloud className="w-4 h-4" /> Import from Active Directory
        </button>
        <button className="flex items-center gap-2 bg-neutral-800 hover:bg-neutral-700 border border-neutral-700 px-4 py-2 text-sm rounded-md text-gray-200">
          <UploadCloud className="w-4 h-4" /> Import from Okta
        </button>
        <button onClick={() => setShowUserModal(true)} className="flex items-center gap-2 bg-neutral-800 hover:bg-neutral-700 border border-neutral-700 px-4 py-2 text-sm rounded-md text-gray-200">
          <ShieldCheck className="w-4 h-4" /> Users Management
        </button>

        <button onClick={() => refreshRoles()} className="flex items-center gap-2 bg-neutral-800 hover:bg-neutral-700 border border-neutral-700 px-4 py-2 text-sm rounded-md text-gray-200">
          <RefreshCw className="w-4 h-4" /> Refresh
        </button>
      </div>

      {/* Roles Table */}
      <div className="overflow-x-auto rounded border border-neutral-800">
        <table className="min-w-full text-sm text-left text-gray-300">
          <thead className="bg-neutral-900 text-gray-400">
            <tr>
              <th className="px-4 py-2">Role</th>
              <th className="px-4 py-2">Admin</th>
              <th className="px-4 py-2">Description</th>
              <th className="px-4 py-2">Assigned Users</th>
              <th className="px-4 py-2 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={4} className="px-4 py-3 text-center">Loading...</td></tr>
            ) : roles.length === 0 ? (
              <tr><td colSpan={4} className="px-4 py-3 text-center text-gray-500">No roles found</td></tr>
            ) : (
              roles.map((role) => (
                <tr key={role.roleId} className="border-t border-neutral-800 hover:bg-neutral-800/30">
                  <td className="px-4 py-3 text-white font-medium">{role.roleName}</td>
                  <td className="px-4 py-3 text-white font-medium">{role.isadmin ? 'Yes' : 'No'}</td>
                  <td className="px-4 py-3">{role.description}</td>
                  <td className="px-4 py-3">
                    {role.assignedUsers.length > 0 ? (
                      role.assignedUsers.map((u) => u.email).join(', ')
                    ) : (
                      <span className="text-gray-500">No users</span>
                    )}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <button
                      onClick={() => handleAssignClick(role)}
                      className="text-indigo-400 hover:text-white text-sm flex items-center gap-1"
                    >
                      <UserPlus className="w-4 h-4" /> Assign Users
                    </button>

                    <button
                      onClick={() => handleViewRoutes(role)}
                      className="text-indigo-400 hover:text-white text-sm flex items-center gap-1"
                    >
                      <ShieldCheck className="w-4 h-4" /> Access Setting
                    </button>

                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Modals */}
      {showUserModal && <UserManagementModal onClose={() => setShowUserModal(false)} />}
      {showAssignModal && activeRole && (
        <AssignUsersModal
          roleName={activeRole.roleName}
          assignedUsers={activeRole.assignedUsers.map(u => ({
            id: u.userId,
            email: u.email,
            firstName: u.firstName,
            lastName: u.lastName,
            isActive: true // optional if backend returns it
          }))}
          availableUsers={allSystemUsers}
          onClose={() => setShowAssignModal(false)}
          onAssign={handleAssignUser}
          onRemove={handleRemoveUser}
        />
      )}

      {showRoutesModal && activeRole && (
        // <ViewRoutePrivilegesModal
        //   roleName={activeRole.roleName}
        //   routes={routesForRole}
        //   onClose={() => setShowRoutesModal(false)}
        // />
        <ViewRoutePrivilegesModal
          roleName={activeRole.roleName}
          roleId={activeRole.roleId}
          tenantId={tenantId}
          routes={routesForRole}
          onClose={() => setShowRoutesModal(false)}
        />

      )}

    </div>
  );
};

export default AccessSettings; 